import React, { useContext } from 'react';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import CreateOUButton from './CreateOUButton';
import OrgSettingMenu from './orgSettingMenu';
import WASettingMenu from './waSettingMenu';
import MRSettingMenu from './mrSettingMenu';
import { SettingMenuContext } from './content';

export function BottomSession(props) {
  const aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>{APP.LANGUAGE.EntityAdmin.InfoPartOne}</p>
      <div>
        <span className="bold">{APP.LANGUAGE.EntityAdmin.SearchPlaceholder + ':'}&nbsp;</span>
        <span>{APP.LANGUAGE.EntityAdmin.InfoPartTwo}</span>
        <span className="bold">{APP.LANGUAGE.EntityAdmin.ShowAll}</span>
        <span>{APP.LANGUAGE.EntityAdmin.InfoPartThree}</span>
      </div>
    </div>
  );
  const options = [
    {
      title: APP.LANGUAGE.RightHandSidePanel.AboutThisPage,
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  const activeIndexOfPage = window.localStorage.getItem(`entityAdminActiveIndex-${props.userId}`);
  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      pagePrefix="entityAdminActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}

export default function RightPanelOrTopPanel(props) {
  const { entityFilter, fetchingStatsIndicator } = useContext(SettingMenuContext);
  const [filterValue, setFilterValue] = entityFilter;
  const [fetchingRHSStats, setFetchingRHSStats] = fetchingStatsIndicator;

  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
          </div>
          <MRSettingMenu
            entityAdminRights={props.entityAdminRights}
            handleClick={props.handleClick}
            closeMenu={props.closeMenu}
            isOnMobileOrTablet={false}
            waitingArea={props.waitingArea}
            isConsultNowFeatureEnabled={props.isConsultNowFeatureEnabled}
          />
          <WASettingMenu
            isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
            entityAdminRights={props.entityAdminRights}
            handleClick={props.handleClick}
            isConsultNowFeatureEnabled={props.isConsultNowFeatureEnabled}
            waitingArea={props.waitingArea}
            closeMenu={props.closeMenu}
            isOnMobileOrTablet={false}
            isRecordingFeatureEnabled={props.isRecordingFeatureEnabled}
            WAOURecordingEnable={props.WAOURecordingEnable}
            isFullNameFeatureEnabled={props.isFullNameFeatureEnabled}
            isChatFeatureEnabled={props.isChatFeatureEnabled}
          />
          <OrgSettingMenu
            isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
            entityAdminRights={props.entityAdminRights}
            handleClick={props.handleClick}
            closeMenu={props.closeMenu}
            isOnMobileOrTablet={false}
            isRecordingFeatureEnabled={props.isRecordingFeatureEnabled}
            isChatFeatureEnabled={props.isChatFeatureEnabled}
            isFullNameFeatureEnabled={props.isFullNameFeatureEnabled}
          />
          {props.entityAdminRights.isAdmin ? (
            <div className="pdbm pdrm pdll">
              <CreateOUButton />
            </div>
          ) : (
            ''
          )}
          <div className="pdbm pdrm pdlm">
            {props.entityStats ? (
              <div className="pdbm pdrm pdlxs mrlxs">
                {filterValue === 1 ? (
                  <div>
                    <span className="bold">{APP.LANGUAGE.EntityAdmin.OUStats}</span>
                    {fetchingRHSStats
                      ? ''
                      : APP.LANGUAGE.EntityAdmin.CountOfTotal.replace(
                          '##count##',
                          props.entityStats.matchedOUs
                        ).replace('##total##', props.entityStats.totalOURows)}
                  </div>
                ) : (
                  ''
                )}
                {filterValue === 1 || filterValue === 2 ? (
                  <div>
                    <span className="bold">{APP.LANGUAGE.EntityAdmin.WAStats}</span>
                    {fetchingRHSStats
                      ? ''
                      : APP.LANGUAGE.EntityAdmin.CountOfTotal.replace(
                          '##count##',
                          props.entityStats.wasOfMatchedOUs
                        ).replace('##total##', props.entityStats.totalWAs)}
                  </div>
                ) : (
                  ''
                )}
                {filterValue === 1 || filterValue === 3 ? (
                  <div>
                    <span className="bold">{APP.LANGUAGE.EntityAdmin.MRStats}</span>
                    {fetchingRHSStats
                      ? ''
                      : APP.LANGUAGE.EntityAdmin.CountOfTotal.replace(
                          '##count##',
                          props.entityStats.mrsOfMatchedOUs
                        ).replace('##total##', props.entityStats.totalMRs)}
                  </div>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="pdbm pdrm pdlm">
            <BottomSession userId={props.userId} />
          </div>
        </div>
      </Container>
    </div>
  );
}
